import { useState, useEffect } from 'react';
import api from '../lib/api';
import { CF_REQUEST_TIMEOUT_MS } from '../utils/campaignFinanceUtils';

export interface CommitteeTypeOption {
  value: string;
  label: string;
  count: number;
}

/**
 * Data-driven recipient committee-type options for the Campaign Finance filter.
 * Pulls the distinct committee types from the dedicated
 * GET /campaign-finance/committee-types endpoint — the same values the
 * committee_type search filter matches against.
 */
export function useCommitteeTypes(): { options: CommitteeTypeOption[]; loading: boolean } {
  const [options, setOptions] = useState<CommitteeTypeOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get('/campaign-finance/committee-types', { timeout: CF_REQUEST_TIMEOUT_MS })
      .then(res => {
        if (cancelled) return;
        const list = res.data?.data || [];
        setOptions(
          list
            .filter((o: { value?: string }) => o.value)
            .map((o: { value: string; label?: string; count?: number | string }) => ({
              value: String(o.value),
              label: String(o.label ?? o.value),
              count: Number(o.count) || 0,
            }))
        );
      })
      .catch(() => { /* non-fatal: the dropdown simply shows only "All Committees" */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { options, loading };
}
